import { useSearch, createFileRoute } from "@tanstack/react-router";
import { AmazonApiConnections } from "../../../../modules/onboarding/amazon/AmazonApiConnections";
import { WalmartApiConnections } from "../../../../modules/onboarding/walmart/WalmartApiConnections";
import { ShopifyApiConnection } from "../../../../modules/onboarding/shopify/ShopifyApiConnection";

const APIConnections = () => {
  const channel = useSearch({ strict: false, select: (s) => s.channel }) ?? "amazon";

  if (channel === "shopify") {
    return <ShopifyApiConnection />;
  }

  if (channel === "walmart") {
    return <WalmartApiConnections />;
  }

  return <AmazonApiConnections />;
};

export const Route = createFileRoute("/_authenticated/onboarding/v2/connect")({
  component: APIConnections,
});
